import PropTypes from 'prop-types';

const KeysIcon = () => (
  <svg
    width="120"
    height="92"
    viewBox="0 0 120 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.8841 39.1723C28.0909 56.2734 39.6964 72.4024 56.7974 75.1903C73.8985 77.9835 90.0275 66.3781 92.8154 49.277C95.6086 32.1759 84.0032 16.0469 66.9021 13.259C49.8011 10.4658 33.672 22.0712 30.8841 39.1723ZM58.6774 25.0727C59.2328 21.6814 62.4266 19.3849 65.8179 19.935C69.2093 20.4904 71.5058 23.6842 70.9557 27.0755C70.4003 30.4669 67.2065 32.7634 63.8152 32.2133C60.4238 31.6579 58.1273 28.4641 58.6774 25.0727Z"
      fill="#FFCCEF"
    />
    <path
      d="M92.052 37.5324C101.852 33.1049 106.21 21.5743 101.783 11.774C97.3553 1.97376 85.8247 -2.38429 76.0244 2.04319"
      stroke="#FB6E44"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M106.493 86.7424L116.827 91.688L119.872 80.7021L104.287 46.1902L90.9087 52.2359L106.493 86.7424Z"
      fill="#0A0777"
    />
    <path
      d="M69.8072 41.8048L77.2629 58.3077C79.2229 62.6444 84.3233 64.5724 88.66 62.6124L113.569 51.3648C117.906 49.4047 119.834 44.3043 117.874 39.9676L110.418 23.4647C108.458 19.128 103.358 17.2 99.0211 19.1601L74.1118 30.4077C69.7751 32.3677 67.8471 37.4682 69.8072 41.8048ZM86.6359 39.7059C85.2526 36.6457 86.6145 33.0407 89.6748 31.6628C92.735 30.2795 96.34 31.6414 97.7179 34.7016C99.0958 37.7619 97.7393 41.3669 94.679 42.7448C91.6188 44.1281 88.0138 42.7662 86.6359 39.7059Z"
      fill="#0A0777"
    />
    <path
      d="M120 68.1505L111.53 87.3825L99.9722 61.7843L120 68.1505Z"
      fill="#0A0777"
    />
    <path
      d="M116.443 60.2621L107.972 79.4941L96.4097 53.9012L116.443 60.2621Z"
      fill="#0A0777"
    />
    <path
      d="M88.5672 59.0529L110.968 48.9386C114.334 47.419 115.83 43.4585 114.31 40.0928L107.957 26.0207C106.437 22.6549 102.476 21.1584 99.1107 22.6781L76.7102 32.7923C73.3444 34.312 71.8479 38.2724 73.3676 41.6382L79.7214 55.7103C81.2411 59.0761 85.2015 60.5726 88.5672 59.0529Z"
      stroke="white"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M110.921 85.0439L114.654 86.9826L115.674 82.9022L104.138 57.3628L99.3901 59.5044L110.921 85.0439Z"
      stroke="white"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M76.0245 2.04333C66.2242 6.47081 61.8662 18.0015 66.2937 27.8017C70.7212 37.602 82.2518 41.96 92.0521 37.5326"
      stroke="#FB6E44"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M3.49932 2.96045H48.1663C50.0963 2.96045 51.6656 4.92805 51.6656 7.35622V40.0537H3.49932C1.56927 40.0537 0 38.0861 0 35.6579V7.35622C0 4.93173 1.56634 2.96045 3.49932 2.96045Z"
      fill="white"
    />
    <path d="M51.675 47.2375L36.3389 34.7544H51.675V47.2375Z" fill="white" />
    <path
      d="M46.0161 8.64526L39.1841 15.4773"
      stroke="#0A0777"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M39.1841 8.64526L46.0161 15.4773"
      stroke="#0A0777"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M14.4593 23.9296C18.7866 23.9296 22.2946 20.4216 22.2946 16.0943C22.2946 11.767 18.7866 8.25903 14.4593 8.25903C10.132 8.25903 6.62402 11.767 6.62402 16.0943C6.62402 20.4216 10.132 23.9296 14.4593 23.9296Z"
      fill="#C9E3F7"
    />
    <path
      d="M6.75049 28.1304H46.0157"
      stroke="#0A0777"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
    <path
      d="M6.75049 35.1824H46.0157"
      stroke="#0A0777"
      strokeWidth="0.379801"
      strokeMiterlimit="10"
    />
  </svg>
);

export default KeysIcon;
